import { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';

import { MDText } from 'i18n-react';

import cypressIds from 'CypressId';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { applyCypressData } from 'Utilities';
import { VERIFICATION_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsDocumentVerification';

import { DOCUMENT_CAPTURE_ROUTE_NAMES } from '../DocumentCapture.helpers';
import LocalTexts from '../DocumentCapture.texts.json';
import { DocumentCaptureConfirmationProgressContext } from '../DocumentCaptureContexts';

import docReviewImageSrc from './assets/docReview.svg';
import { useGetVerificationStatus } from './useGetVerificationStatus';

import styles from './ReviewStatusIncodeView.scss';

const LocalT = new MDText(LocalTexts.reviewStatus);

export const ReviewStatusIncodeView = () => {
  const { progress: { bankDetailsAdded, bankDetailsReviewFailed } } = useContext(
    DocumentCaptureConfirmationProgressContext,
  ) || {};

  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { enquiry } = vehicle || {};
  const enquiryId = enquiry?.dpEnquiryId;

  const bankDetailsIncomplete = !bankDetailsAdded || bankDetailsReviewFailed;

  const [loadingMessage, setLoadingMessage] = useState(LocalT.translate('inProgress.incodeSubtitle'));

  useEffect(() => {
    if (!bankDetailsIncomplete) {
      VERIFICATION_ANALYTICS_EVENTS.DOCS_IN_REVIEW({ label: 'incode-review' });
    }
  }, [bankDetailsIncomplete]);

  useGetVerificationStatus({
    enquiryId: enquiryId!,
    onError: () => {
      setLoadingMessage("This is taking longer than expected. We'll be in touch via email.");
    },
    onSuccess: () => {
      // If the verification is completed, we need to redirect the user?
      // Perhaps to /{vrm}/confirm-sale-status to handle internal logic
    },
  });

  // If a seller decides to upload documents before adding bank details,
  // we need to redirect them to the bank details page
  if (bankDetailsIncomplete) {
    return <Redirect to={DOCUMENT_CAPTURE_ROUTE_NAMES.ADD_BANK_DETAILS} />;
  }

  return (
    <div className={styles.reviewStatusIncode} {...applyCypressData(cypressIds.sections.reviewStatusSubview)}>
      <div className={styles.imageContainer}>
        <img alt="docReviewImage" className={styles.docReviewImage} src={docReviewImageSrc} />
      </div>
      <div className={styles.heading}>
        <h3 className={styles.headingTitle}>{LocalT.translate('inProgress.incodeTitle')}</h3>
        <p className={styles.headingSubTitle}>{loadingMessage}</p>
      </div>
    </div>
  );
};
